(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["central-command-popup"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cc-popup').forEach((popup)=>{const key='central-command-popup-seen';const close=popup.querySelector('.cc-popup__close');if(!sessionStorage.getItem(key)){window.setTimeout(()=>popup.showModal(),1200)}close.addEventListener('click',()=>{popup.close();sessionStorage.setItem(key,'1')});popup.addEventListener('click',(event)=>{if(event.target===popup){popup.close();sessionStorage.setItem(key,'1')}})});

  } catch(e) { console.error(e); }
})();
})();
